var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 10.333C9.47398 10.333 10.6673 9.13967 10.6673 7.66634V3.99967C10.6673 2.52634 9.47398 1.33301 8.00065 1.33301C6.52732 1.33301 5.33398 2.52634 5.33398 3.99967V7.66634C5.33398 9.13967 6.52732 10.333 8.00065 10.333Z",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 6.43359V7.56693C2.90039 10.3803 5.18706 12.6669 8.00039 12.6669C10.8137 12.6669 13.1004 10.3803 13.1004 7.56693V6.43359",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07422 4.28707C7.67422 4.06707 8.32755 4.06707 8.92755 4.28707",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4668 5.69988C7.82013 5.60655 8.1868 5.60655 8.54013 5.69988",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.667V14.667",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneIcon);
export default __webpack_public_path__ + "static/media/MicrophoneIcon.273ba9e858683a12a44fd848861fb470.svg";
export { ForwardRef as ReactComponent };